import { render, staticRenderFns } from "./BuildingRenovationAndWaterAndElectricityMaintenanceStaff.vue?vue&type=template&id=5e3f633d&"
import script from "./BuildingRenovationAndWaterAndElectricityMaintenanceStaff.vue?vue&type=script&lang=js&"
export * from "./BuildingRenovationAndWaterAndElectricityMaintenanceStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports